import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3, 0)
  },
  section: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2)
  },
  heading: {
    marginBottom: theme.spacing(2)
  },
  subtitle: {
    color: theme.palette.grey[600],
    marginTop: theme.spacing(0.5)
  },
  filters: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  },
  tableWrapper: {
    marginTop: theme.spacing(2),
    overflowX: 'auto'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(5)
  },
  empty: {
    color: theme.palette.grey[600],
    padding: theme.spacing(5),
    textAlign: 'center'
  },
  error: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(4)
  },
  pagination: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  },
  success: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText
  },
  failure: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText
  },
  challenge: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText
  },
  retentionRow: {
    alignItems: 'flex-end',
    display: 'flex',
    gap: theme.spacing(2),
    maxWidth: 640,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column'
    }
  },
  retentionInput: {
    flex: 1
  }
}))

export default useStyles
